<template>
    <div :class="portalContentAndDesignStore.getPageContainerClasses">
        <form id="partner-signup">
            <div
                class="mb-6 space-y-4"
                :class="[
                  'mb-6 space-y-4',
                  portalContentAndDesignStore.getPageContentTextColorClass
                ]"
            >
                <form-errors :store-form-errors="portalContentAndDesignStore.signupFormErrors" />

                <signup-custom-fields />
            </div>

            <!-- Terms of Use -->
            <div v-if="portalContentAndDesignStore.signupPageSettings?.signup.portal_signup_tos_url || portalContentAndDesignStore.signupPageSettings?.signup.portal_signup_tos_text" class="space-x-2 flex text-sm my-6">
                <input
                    type="checkbox"
                    name="tos"
                    id="tos"
                    :class="portalContentAndDesignStore.getCheckboxInputStyle"
                    v-model="portalContentAndDesignStore.signupFormData.tos"
                />
                <editable-text-field
                   text-type="label"
                   for-attribute="tos"
                   :class="portalContentAndDesignStore.getPageContentTextColorClass"
                   v-model="portalContentAndDesignStore.translationSettings.portal_translation_signup_i_agree"
                >
                </editable-text-field>
                <template v-if="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_saved_locally && portalContentAndDesignStore.signupPageSettings?.signup.portal_signup_tos_text">
                    <modal
                        :title="portalContentAndDesignStore.translationSettings.portal_translation_signup_terms_of_use"
                        size="huge"
                        class="text-gray-900 inline-block"
                        @modal-close="isEditingTosModal = false"
                    >
                        <template #toggle>
                            <a href="#"
                               :class="[
                                   'relative hover:underline text-opacity-100',
                                   portalContentAndDesignStore.getLinkColorClass
                               ]"
                               @mouseenter="tosModalHoverActive = true"
                               @mouseleave="tosModalHoverActive = false"
                            >
                                <!-- Let's just show icon and, for the sake of simplicity, do editing in the modal -->
                                <edit-toggle-button
                                    v-show="portalContentAndDesignStore.liveDesignerEnabled && (tosModalHoverActive)"
                                    :isEditing="isEditingTosModal"
                                    @toggle="isEditingTosModal = !isEditingTosModal"
                                    edit-button-position="inside-right"
                                    :stop-propagation="isEditingTosModal"
                                    class="transition-opacity duration-200"
                                />
                                {{ portalContentAndDesignStore.translationSettings.portal_translation_signup_terms_of_use }}
                            </a>
                        </template>
                        <template #body>
                            <div v-if="portalContentAndDesignStore.liveDesignerEnabled && isEditingTosModal" class="space-y-2 mb-4">
                                <p class="text-sm text-gray-400" >Edit link text here</p>
                                <editable-text-field
                                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_signup_terms_of_use"
                                    text-type="a"
                                    href="#"
                                    :class="[
                                    'text-opacity-100 hover:underline',
                                    portalContentAndDesignStore.getLinkColorClass
                                ]"
                                />
                            </div>
                            <editable-text-editor-field v-if="portalContentAndDesignStore.liveDesignerEnabled && isEditingTosModal"
                                class="space-y-2 text-gray-500 partnero-page-content-block"
                                v-model="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_text"
                            />
                            <div v-else
                                 class="space-y-2 text-gray-500 partnero-page-content-block"
                                 v-html="portalContentAndDesignStore.signupPageSettings?.signup.portal_signup_tos_text"
                            />
                        </template>
                    </modal>
                </template>
                <template v-else>
                    <editable-link-field
                        v-model:label="portalContentAndDesignStore.translationSettings.portal_translation_signup_terms_of_use"
                        v-model:url="portalContentAndDesignStore.signupPageSettings.signup.portal_signup_tos_url"
                        link-target="_blank"
                        :link-classes="portalContentAndDesignStore.getLinkColorClass"
                    />
                </template>
            </div>

            <!-- Marketing Consent -->
            <div v-if="portalContentAndDesignStore.signupPageSettings?.signup.marketing_consent" class="space-x-2 flex text-sm my-6">
                <input
                    type="checkbox"
                    name="marketing_consent"
                    id="marketing_consent"
                    :class="portalContentAndDesignStore.getCheckboxInputStyle"
                    v-model="portalContentAndDesignStore.signupFormData.marketing_consent"
                />
                <editable-text-field
                    text-type="label"
                    v-model="portalContentAndDesignStore.signupPageSettings.signup.marketing_consent"
                    for-attribute="marketing_consent"
                    :class="portalContentAndDesignStore.getPageContentTextColorClass"
                />
            </div>

            <!-- Register Button -->
            <editable-btn
                :prevent-double-click="5000"
                size="huge"
                class="w-full"
                :type="portalContentAndDesignStore.getPageContentButtonColorClass"
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_signup_register"
                @click="onSubmit"
            />

            <!-- Social Auth -->
            <template v-if="portalContentAndDesignStore.portalLayoutSettings.portal_affiliate_enable_partners_to_login_signup_via_google">
                <div class="flex flex-row items-center justify-center my-4">
                    <div class="w-full">
                        <hr>
                    </div>
                    <div class="px-4">
                        <editable-text-field
                            v-model="portalContentAndDesignStore.translationSettings.portal_translation_signup_or"
                            class="block text-sm opacity-80 mb-1.5"
                            :class="portalContentAndDesignStore.getPageContentTextColorClass"
                            text-type="span"
                        >
                        </editable-text-field>
                    </div>
                    <div class="w-full">
                        <hr>
                    </div>
                </div>

                <editable-social-auth-btn
                    social-provider="google"
                    :social-submit-url="portalContentAndDesignStore.getSocialAuthRegisterRedirectRoute('google')"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_signup_with_google"
                />
            </template>

        </form>

        <!-- Already have an account -->
        <div class="pt-6 text-sm text-center" :class="portalContentAndDesignStore.getPageContentTextColorClass">
            <div class="flex space-x-1 justify-center">
                <editable-text-field
                    text-type="span"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_signup_already_have_an_account"
                />
                <editable-text-field
                    text-type="a"
                    :href="portalContentAndDesignStore.getLoginRoute"
                    :class="[
                            'hover:underline text-opacity-100',
                            portalContentAndDesignStore.getLinkColorClass
                         ]"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_signup_log_in"
                >
                </editable-text-field>
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed, ref} from "vue";
import { usePortalContentAndDesignStore } from "../../../../../stores/partners/portalContentAndDesignStore";
import EditableBtn from "../../../portal-editable-fields/EditableBtn.vue";
import EditableTextField from "../../../portal-editable-fields/EditableTextField.vue";
import EditableLinkField from "../../../portal-editable-fields/EditableLinkField.vue";
import EditableTextEditorField
    from "../../../portal-editable-fields/EditableTextEditorField.vue";
import EditToggleButton from "../../components/EditToggleButton.vue";
import SignupCustomFields from "./includes/SignupCustomFields.vue";
import FormErrors from "../Errors/FormErrors.vue";
import EditableSocialAuthBtn from "../../../portal-editable-fields/EditableSocialAuthBtn.vue";
import {scrollToTop} from "../../../../../helpers/common";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const tosModalHoverActive = ref(false);
const isEditingTosModal = ref(false);

const submitRegistration = (recaptchaToken = null) => {
    portalContentAndDesignStore.resetFormErrors('signup')

    const payload = portalContentAndDesignStore.signupFormData

    if (recaptchaToken) {
        payload['g-recaptcha-response'] = recaptchaToken
    }

    axios.post(route('partners_int.portal-register.register'), payload)
        .then((response) => {
            if (+response.data.status === 1) {
                portalContentAndDesignStore.resetFormErrors('signup')
                window.location.href = response.data.redirect_url;
            } else {
                portalContentAndDesignStore.signupFormErrors.responseError = response.data?.error;
                portalContentAndDesignStore.signupFormData.password = '';
                scrollToTop()
            }
        })
        .catch((error) => {
            if (error.response && error.response.status === 422) {
                portalContentAndDesignStore.signupFormErrors.validationErrors = error.response?.data?.errors;
                scrollToTop()
            } else {
                console.log('Response error:', error.response);
                portalContentAndDesignStore.signupFormErrors.responseError = error.response?.data?.error || 'An error occurred. See console for details.';
            }
        });

};

const onSubmit = () => {
    const recaptchaSettings = portalContentAndDesignStore.recaptchaSettings;

    if (recaptchaSettings?.portal_recaptcha_enabled) {
        grecaptcha.ready(() => {
            grecaptcha.execute(recaptchaSettings.portal_recaptcha_site_key, { action: "signup" }).then((token) => {
                submitRegistration(token);
            });
        });
    } else {
        submitRegistration();
    }
};
</script>
